    <h1>Post IPD <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
    <div class="row"  *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
    <div class="row" *ngIf="dataLoaded">
        <div class="col-sm-8 border-right">
        <form [formGroup]="IpdForm" (submit)="updateIpd()">
            <div class="col-md-12 mb-sm-4 mt-sm-4" #screen>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Patient Name *</label>
                        <input type="text" [readonly]="myrole==5" formControlName="patient_name" class="form-control" />
                        <div *ngIf="submitted && f.patient_name.errors" class="invalid-feedback">
                            <div *ngIf="f.patient_name.errors.required">Patient Name is required</div>
                        </div>
                        <div *ngIf="(f.patient_name.value=='NA' || f.patient_name.value=='N/A') && invalidName" class="invalid-feedback">
                            <div>Please enter valid name</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Patient Mobile *</label>
                        <input type="text" value="XXXXXXXXXX" class="form-control readOnly" />
                        <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                            <div *ngIf="f.mobile.errors.required">Patient Mobile is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Patient Age *</label>
                        <input type="number" formControlName="patient_age" class="form-control" />
                        <div *ngIf="submitted && f.patient_age.errors" class="invalid-feedback">
                            <div *ngIf="f.patient_age.errors.required">Patient Age is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Gender *</label>
                        <mat-select placeholder="Gender" formControlName="gender">
                            <mat-option value="Male">Male</mat-option>
                            <mat-option value="Female">Female</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                            <div *ngIf="f.gender.errors.required">Patient Gender is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label" >Select Doctor *</label>
                        <mat-select placeholder="Select Doctor" [ngClass]="{'readOnly':myrole=='5'}" formControlName="doctor_id" (click)="setSearchValue('doctor')">
                            <input class="mySearchInput"
                            #doctorSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'doctor')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="doctorSearch">
                            <mat-option value="">Select Doctor</mat-option>
                            <mat-option [value]="doctor.id" *ngFor="let doctor of doctors">{{doctor.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.doctor_id.errors" class="invalid-feedback">
                            <div *ngIf="f.doctor_id.errors.required">Doctor is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Select Hospital *</label>
                        <mat-select placeholder="Select Hospital" [ngClass]="{'readOnly':myrole=='5'}" formControlName="hospital_id" (click)="setSearchValue('hospital')">
                            <input class="mySearchInput"
                            #hospitalSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'hospital')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="hospitalSearch">
                            <mat-option value="">Select Hospital</mat-option>
                            <mat-option [value]="hospital.id" *ngFor="let hospital of hospitals">{{hospital.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.hospital_id.errors" class="invalid-feedback">
                            <div *ngIf="f.hospital_id.errors.required">Hospital is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Treatment *</label>
                         <!-- <mat-select placeholder="Select Treatment" [ngClass]="{'readOnly':myrole=='5'}" formControlName="treatment_id" (selectionChange)="AddRemoveValidation($event)" (click)="setSearchValue('treatment')"> -->
                        <mat-select placeholder="Select Treatment" [ngClass]="{'readOnly':(IpdForm.controls['payment_mode'].value==2 || IpdForm.controls['payment_mode'].value==3) && (myrole=='2' || myrole=='3')}" formControlName="treatment_id" (selectionChange)="AddRemoveValidation($event)" (click)="setSearchValue('treatment')">
                            <input class="mySearchInput"
                            #treatmentSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'treatment')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="treatmentSearch">
                            <mat-option value="">Select Treatment</mat-option>
                            <mat-option [value]="treatment.id" *ngFor="let treatment of treatments">{{treatment.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.treatment_id.errors" class="invalid-feedback">
                            <div *ngIf="f.treatment_id.errors.required">Treatment is required</div>
                        </div>
                        <div *ngIf="f.treatment_id.value=='37' && invalidTreatment" class="invalid-feedback">
                            <div>Please select valid treatment</div>
                        </div>
                    </div>
                    <div class="col-sm-6" *ngIf="f.treatment_id.value == 159 || f.treatment_id.value == 172 || f.treatment_id.value == 96 || f.treatment_id.value == 170">
                        <label class="form-label">Lipoma, Mole & Cyst Count*</label>
                        <input type="text" formControlName="lmcCount" class="form-control" />
                        <div *ngIf="submitted && f.lmcCount.errors" class="invalid-feedback">
                            <div *ngIf="f.lmcCount.errors.required">Lipoma, Mole & Cyst count is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6 mt-2">
                        <label class="form-label">Select BD *</label>
                        <mat-select placeholder="Select BD" [ngClass]="{'readOnly':myrole!='1'}" formControlName="user_id" (click)="setSearchValue('lead_owner')">
                            <input class="mySearchInput"
                            #ownerSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="ownerSearch">
                            <mat-option value="">Select BD</mat-option>
                            <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                            <div *ngIf="f.user_id.errors.required">BD is required</div>
                        </div>
                        <div *ngIf="f.user_id.value=='21' && invalidBd" class="invalid-feedback">
                            <div>Please select valid BD</div>
                        </div>
                    </div>
                    <div class="col-sm-6 mt-2" *ngIf="f.treatment_id.value == 129">
                        <label class="form-label">Lens Type *</label>
                        <mat-select placeholder="Lens Type" formControlName="lens_type">
                            <mat-option value="Indian Monofocal">Indian Monofocal</mat-option>
                            <mat-option value="Indian Multifocal">Indian Multifocal</mat-option>
                            <mat-option value="Indian Bi-Focal">Indian Bi-Focal</mat-option>
                            <mat-option value="Indian Trifocal">Indian Trifocal</mat-option>
                            <mat-option value="Imported Monofocal">Imported Monofocal</mat-option>
                            <mat-option value="Imported Multifocal">Imported Multifocal</mat-option>
                            <mat-option value="Imported Bi-Focal">Imported Bi-Focal</mat-option>
                            <mat-option value="Imported Trifocal">Imported Trifocal</mat-option>
                          
                        </mat-select>
                        <div *ngIf="submitted && f.lens_type.errors" class="invalid-feedback">
                            <div *ngIf="f.lens_type.errors.required">Lens Type is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6 mt-2" *ngIf="f.treatment_id.value == 129">
                        <label class="form-label">Lens Price *</label>
                        <input type="number" formControlName="lens_price" class="form-control" />
                        <div *ngIf="submitted && f.lens_price.errors" class="invalid-feedback">
                            <div *ngIf="f.lens_price.errors.required">Lens Price is required</div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Select Room *</label>
                        <mat-select [ngClass]="{'readOnly':disabledInput}" placeholder="Select Room" formControlName="room">
                            <mat-option value="">Select Room</mat-option>
                            <mat-option [value]="1" >Single Private</mat-option>
                            <mat-option [value]="2" >Double Sharing</mat-option>
                            <!-- <mat-option [value]="4" >Three Sharing</mat-option> -->
                            <mat-option [value]="3" >General Ward</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.room.errors" class="invalid-feedback">
                            <div *ngIf="f.room.errors.required">Room is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Surgery Date *</label>
                        <mat-form-field appearance="fill" [ngClass]="{'readOnly':myrole=='2' && IpdChk}">
                            <mat-label>Choose a date</mat-label>
                            <input [ngClass]="{'readOnly':myrole=='2' && IpdChk}" matInput readonly formControlName="surgery_date"  [readonly]="myrole=='5'" [matDatepicker]="picker">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <div *ngIf="submitted && f.surgery_date.errors" class="invalid-feedback">
                            <div *ngIf="f.surgery_date.errors.required">Surgery Date is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <label class="form-label">Surgery Date Change Reason</label>
                        <textarea  formControlName="surgery_change_reason" class="form-control" ></textarea>
                        
                    </div>
                </div>
            </div>
            <hr>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Select Payment Mode *</label>
                        <mat-select [ngClass]="{'readOnly':disabledInput}" placeholder="Select Payment Mode" formControlName="payment_mode" (selectionChange)="setpaymentType()">
                            <mat-option value="">Select Payment Mode</mat-option>
                            <mat-option [value]="1">Cash</mat-option>
                            <mat-option [value]="2">Cashless</mat-option>
                            <mat-option [value]="3">Reimbursement</mat-option>
                            <mat-option [value]="4">EMI</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.payment_mode.errors" class="invalid-feedback">
                            <div *ngIf="f.payment_mode.errors.required">Payment Mode is required</div>
                        </div>
                    </div>
                    
                    <div class="col-sm-6" *ngIf="f.payment_mode.value == 4">
                        <label class="form-label">EMI Vendor Name*</label>
                        <mat-select placeholder="EMI Vendor Name" formControlName="emivendor">
                            <mat-option value="">EMI Vendor Name</mat-option>
                            <mat-option [value]="1">Early Salary</mat-option>
                            <mat-option [value]="2">G-Money</mat-option>
                            <mat-option [value]="3">Unofin</mat-option>
                            <mat-option [value]="4">Shopsy</mat-option>
                            <mat-option [value]="5">Credit Fair</mat-option>
                            <mat-option [value]="6">Bajaj Finserv EMI</mat-option>
                            <mat-option [value]="7">Mahila Money</mat-option>
                            <mat-option [value]="8">Liquiloans</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.emivendor.errors" class="invalid-feedback">
                            <div *ngIf="f.emivendor.errors.required">EMI Vendor Name is required</div>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-4" *ngIf="f.payment_mode.value == 4">
                        <label class="form-label">Loan Approved Amount*</label>
                        <input type="text" formControlName="load_approved_amt" class="form-control" />
                        <div *ngIf="submitted && f.load_approved_amt.errors" class="invalid-feedback">
                            <div *ngIf="f.load_approved_amt.errors.required">Loan Approved Amount is required</div>
                        </div>
                    </div>
                    <div class="col-sm-4" *ngIf="f.payment_mode.value == 4">
                        <label class="form-label">Subvention Amount*</label>
                        <input type="text" formControlName="sub_variation_amt" class="form-control" />
                        <div *ngIf="submitted && f.sub_variation_amt.errors" class="invalid-feedback">
                            <div *ngIf="f.sub_variation_amt.errors.required">Subvention Amount is required</div>
                        </div>
                    </div>
                    <div class="col-sm-4" *ngIf="f.payment_mode.value == 4">
                        <label class="form-label">Downpayment Amount*</label>
                        <input type="text" formControlName="downpayment_amt" class="form-control" />
                        <div *ngIf="submitted && f.downpayment_amt.errors" class="invalid-feedback">
                            <div *ngIf="f.downpayment_amt.errors.required">Downpayment Amount is required</div>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6" *ngIf="f.payment_mode.value == 4">
                        <label class="form-label">Select Monthly Income *</label>
                        <mat-select placeholder="Select Monthly Income" formControlName="monthly_income">
                            <mat-option value="">Select Monthly Income</mat-option>
                            <mat-option [value]="1">Less than 10000</mat-option>
                            <mat-option [value]="2">10000 - 20000</mat-option>
                            <mat-option [value]="3">20000 - 30000</mat-option>
                            <mat-option [value]="4">30000 - 40000</mat-option>
                            <mat-option [value]="5">40000 - 50000</mat-option>
                            <mat-option [value]="6">More than 50000</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.monthly_income.errors" class="invalid-feedback">
                            <div *ngIf="f.monthly_income.errors.required">Select Monthly Income is required</div>
                        </div>
                    </div>
                    
                    <div class="col-sm-6" *ngIf="f.payment_mode.value == 4">
                        <label class="form-label">Bank Balance*</label>
                        <input type="text" placeholder="Bank Balance" formControlName="bank_balance" class="form-control" />
                        <div *ngIf="submitted && f.bank_balance.errors" class="invalid-feedback">
                            <div *ngIf="f.bank_balance.errors.required">Bank Balance is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>                 
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Arrival Time *</label>
                        <input type="datetime-local" formControlName="arrival_time" [readonly]="myrole=='5'" class="form-control" [min]="disableArrivalPastDate"/>
                        <div *ngIf="submitted && f.arrival_time.errors" class="invalid-feedback">
                            <div *ngIf="f.arrival_time.errors.required">Arrival Time is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Treatment Time *</label>
                        <input type="time" formControlName="treatment_time" [readonly]="myrole=='5'" class="form-control" />
                        <div *ngIf="submitted && f.treatment_time.errors" class="invalid-feedback">
                            <div *ngIf="f.treatment_time.errors.required">Treatment Time is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Attendant Name/Relation *:</label>
                        <textarea  formControlName="attendant" class="form-control" ></textarea>
                        <div *ngIf="submitted && f.attendant.errors" class="invalid-feedback">
                            <div *ngIf="f.attendant.errors.required">Attendant is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Attendant Number *</label>
                        <input type="text" formControlName="attendant_mobile" class="form-control" />
                        <div *ngIf="submitted && f.attendant_mobile.errors" class="invalid-feedback">
                            <div *ngIf="f.attendant_mobile.errors.required">Attendant Number is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-12">
                        <label class="form-label">Tests ( If Any ) *:</label>
                        <textarea  formControlName="test" [readonly]="myrole=='5'" class="form-control" ></textarea>
                        <div *ngIf="submitted && f.test.errors" class="invalid-feedback">
                            <div *ngIf="f.test.errors.required">Tests is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group" *ngIf="isCashHidden">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Admission Amount</label>

                    </div>
                    <div class="col-sm-6">
                        <input [ngClass]="{'readOnly':IpdForm.controls['billed_amt'].value > 0 && myrole!= 1 && myrole!= 9 && IpdChk}" type="text" (keyup)="calculateBilledAmt();" formControlName="admission_amt" class="form-control" />
                        <div *ngIf="submitted && f.admission_amt.errors" class="invalid-feedback">
                            <div *ngIf="f.admission_amt.errors.required">Admission Amount is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group" *ngIf="isCashHidden">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Discharge Amount</label>
                    </div>
                    <div class="col-sm-6">
                        <input type="text" [ngClass]="{'readOnly':IpdForm.controls['billed_amt'].value > 0 && myrole!= 1 && myrole!= 9 && IpdChk}" (keyup)="calculateBilledAmt();" formControlName="discharge_amt" class="form-control" />
                        <div *ngIf="submitted && f.discharge_amt.errors" class="invalid-feedback">
                            <div *ngIf="f.discharge_amt.errors.required">Discharge Amount is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6 mt-sm-4">
                        <label class="form-label">Billed Amount *</label>
                    </div>
                    <div class="col-sm-6 mt-sm-4">
                        <input type="text" (keyup)="calculatesettledAmt('1');" formControlName="billed_amt" class="form-control" [ngClass]="{'readOnly':(IpdForm.controls['payment_mode'].value=='1') || ((IpdForm.controls['payment_mode'].value=='2' || IpdForm.controls['payment_mode'].value=='3') && (myrole!= 1 && myrole!=5 && myrole!=9))}"/>
                        <div *ngIf="submitted && f.billed_amt.errors" class="invalid-feedback">
                            <div *ngIf="f.billed_amt.errors.required">Billed Amount is required</div>
                        </div>
                        <div *ngIf="billedError" class="invalid-feedback">
                            <div>Billed Amount cannot be 0</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="" *ngIf="myrole==1 || myrole==5  || myrole==9">
                <div class="form-group" *ngIf="!isCashHidden">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="form-label">MOU Discount</label>
                        </div>
                        <div class="col-sm-6">
                            <input type="text" formControlName="mou_amount" class="form-control" (keyup)="calculateHiddenAmt();"/>
                        </div>
                    </div>
                </div>

                <div class="form-group" *ngIf="!isCashHidden">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="form-label">Copay <span class="minussign">-</span></label>
                        </div>
                        <div class="col-sm-6">
                            <input type="text" (keyup)="calculateHiddenAmt();" formControlName="copay_amt" class="form-control" />
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="!isCashHidden">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="form-label">Non Consumable <span class="minussign">-</span></label>
                        </div>
                        <div class="col-sm-6">
                            <input type="text" (keyup)="calculateHiddenAmt();" formControlName="non_consuamble_amt" class="form-control" />
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="!isCashHidden">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="form-label">Prop Deduction<span class="minussign">-</span></label>
                        </div>
                        <div class="col-sm-6">
                            <input type="text" (keyup)="calculateHiddenAmt();" formControlName="prop_mou_amt" class="form-control" />
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="!isCashHidden">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="form-label">Insurance Paid</label>
                        </div>
                        <div class="col-sm-6">
                            <input [ngClass]="{'errorborder':insuranceError}" type="text" (keyup)="checkInsuranceAmt();" formControlName="insurance_amt" class="form-control" />
                            <div *ngIf="insuranceError" class="invalid-feedback">
                                <div>Insurance Amount cannot exceed from Billed Amount.</div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="form-group" *ngIf="!isCashHidden">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="form-label">Paitent Due</label>
                        </div>
                        <div class="col-sm-6">
                            <input type="text" formControlName="patient_due_amt" class="form-control" readonly/>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="!isCashHidden">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="form-label">Paitent Paid</label>
                        </div>
                        <div class="col-sm-6">
                            <input [ngClass]="{'errorborder':patientpaidError}" type="text" (keyup)="calculatesettledAmt('2');" formControlName="paitent_paid_amt" class="form-control" />
                            <div *ngIf="patientpaidError" class="invalid-feedback">
                                <div>Paitent Paid Amount cannot exceed from Paitent Due Amount.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6 mb-sm-4">
                        <label class="form-label">Settled Amount</label>
                    </div>
                    <div class="col-sm-6 mb-sm-4">
                        <input type="text" formControlName="settled_amt" class="form-control" readonly/>
                    </div>
                </div>
            </div>

            </div>
            <div *ngIf="myrole==1 || myrole==5">
                <div *ngIf="!isCashHidden" class="btn btn-primary mb-sm-4" (click)="downloadImage()">Capture
                </div>
            </div>
            <div id="download">
                <img #canvas>
                <a #downloadLink></a>
            </div>
            <div class="form-group"  *ngIf="myrole==1">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Hospital Share</label>
                        <input type="text" class="form-control" formControlName="hospital_share" />
                        <div *ngIf="submitted && f.hospital_share.errors" class="invalid-feedback">
                            <div *ngIf="f.hospital_share.errors.required">Hospital Share is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Glamyo Share</label>
                        <input type="text" class="form-control" formControlName="glamyo_share" />
                        <div *ngIf="submitted && f.glamyo_share.errors" class="invalid-feedback">
                            <div *ngIf="f.glamyo_share.errors.required">Glamyo Share is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">

                    <div class="col-sm-12 notediv" *ngIf="myrole!= 1 && myrole!=4">
                        For mark completed Opd. Please upload required documents and coordinate with medical officer or city BD.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6" *ngIf="myrole==1">
                        <label class="form-label">Doctor Share</label>
                        <input type="text" class="form-control" formControlName="doctor_share" />
                        <div *ngIf="submitted && f.doctor_share.errors" class="invalid-feedback">
                            <div *ngIf="f.doctor_share.errors.required">Doctor Share is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Select Status *</label>
                        <mat-select  placeholder="Select Status" [ngClass]="{'readOnly': myrole!= 1 && myrole!=8  && myrole!=9}" formControlName="status" (selectionChange)="setCancelPostponeValidator()">
                            <mat-option value="">Select Status</mat-option>
                            <mat-option [value]="0">Active</mat-option>
                            <mat-option [value]="1">Completed</mat-option>
                            <mat-option [value]="3">Cancel</mat-option>
                            <mat-option [value]="4">Postpone</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                            <div *ngIf="f.user_id.errors.required">Status is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row" *ngIf="IpdForm.controls['status'].value==3||IpdForm.controls['status'].value==4">
                    <div class="col-sm-6 pt-4" >
                        <label class="form-label">Cancel/Postpone Reason*</label>
                        <mat-select placeholder="Select Status" formControlName="cancel_postpone_reason_type">
                            <mat-option value="">Select Cancel/Postpone Reason</mat-option>
                            <mat-option [value]="1">Doctor not available</mat-option>
                            <mat-option [value]="2">OT not available</mat-option>
                            <mat-option [value]="3">Hospital bed not available</mat-option>
                            <mat-option [value]="4">Patient No Show</mat-option>
                            <mat-option [value]="5">Insurance approval pending</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.cancel_postpone_reason_type.errors" class="invalid-feedback">
                            <div *ngIf="f.cancel_postpone_reason_type.errors.required">Cancel/Postpone Reason is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6 pt-4" >
                        <label class="form-label">Cancel/Postpone Comment*</label>
                        <textarea class="form-control" rows="4" formControlName="cancel_postpone_reason"></textarea>
                        <div *ngIf="submitted && f.cancel_postpone_reason.errors" class="invalid-feedback">
                            <div *ngIf="f.cancel_postpone_reason.errors.required">Cancel/Postpone Comment is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Upload Aadhar Card *</label>
                        <input type="file" (change)="selectAadhar($event)" class="form-control" />
                        <div *ngIf="submitted && f.aadhar.errors" class="invalid-feedback">
                            <div *ngIf="f.aadhar.errors.required">Aadhar Card is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="mt-6" *ngIf="myrole==1 || (myrole==3 && CMAccess==1)">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" formControlName="is_specialCase">
                                <span class="custom-control-label">Special Case</span>
                                </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group margintp20">
                <div class="row bordercss">
                    <label class="form-label">Medical Officer Action</label>
                 </div>
                 <div class="row margintp20">
                    <div class="col-sm-6">
                        <label class="form-label">Select Action</label>
                        <mat-select placeholder="Select Action" formControlName="approved_status" [ngClass]="{'readOnly': myrole!= 1 && myrole!=4}">
                            <mat-option value="">Select Status</mat-option>
                            <mat-option [value]="1">Approved</mat-option>
                            <mat-option [value]="2">Rejected</mat-option>
                            <mat-option [value]="3">Approved with High Risk</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="form-label">Comments</label>
                            <textarea class="form-control" formControlName="comments" [ngClass]="{'readOnly': myrole!= 1 && myrole!=4}"></textarea>
                        </div>
                    </div>
                 </div>
            </div>
            <div class="form-group margintp20">
              <div class="row bordercss">
                  <label class="form-label">Cab Details</label>
               </div>
               <div class="row margintp20">
                  <div class="col-sm-6" *ngIf="cabStatus==2">
                    <div class="mt-6">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" formControlName="cab_reschedule" (change)="edit_cab_status($event)">
                            <span class="custom-control-label">Cab Reschedule</span>
                        </label>
                    </div>
                  </div>
                  <div class="col-sm-6">
                      <label class="form-label">Pickup Point</label>
                      <textarea class="form-control" formControlName="pickup_point" [ngClass]="{'readOnly': ((myrole!= 1 && myrole!=2 && myrole!='3') || (cabStatus !=0 && cabStatus !=null)) && editCabStatus == false}" (keyup)="pickupPointChange($event)"></textarea>
                  </div>
                  <div class="col-sm-6">
                      <div class="form-group">
                        <label class="form-label">Pickup Date</label>
                        <mat-form-field appearance="fill">
                            <mat-label>Pickup Date</mat-label>
                            <input matInput readonly formControlName="pickup_date" [matDatepicker]="picker1" [readonly]="((myrole!='1' && myrole!='2' && myrole!='3') || (cabStatus !=0 && cabStatus !=null)) && editCabStatus == false">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        <div *ngIf="submitted && f.pickup_date.errors" class="invalid-feedback">
                            <div *ngIf="f.pickup_date.errors.required">Pickup Date is required</div>
                        </div>
                      </div>
                  </div>
                  <div class="col-sm-6">
                    <label class="form-label">Pickup Time</label>
                    <input type="time" formControlName="pickup_time" class="form-control"  [readonly]="((myrole!='1' && myrole!='2' && myrole!='3') || (cabStatus !=0 && cabStatus !=null) ) && editCabStatus == false" />
                    <div *ngIf="submitted && f.pickup_time.errors" class="invalid-feedback">
                        <div *ngIf="f.pickup_time.errors.required">Pickup Time is required</div>
                    </div>
                </div>
                <div class="col-sm-6">
                  <div class="mt-6">
                       <label class="custom-control custom-checkbox">
                           <input type="checkbox" class="custom-control-input" formControlName="return_cab" [readonly]="myrole!='1' && myrole!='2' && myrole!='3'">
                           <span class="custom-control-label">Return Cab Required</span>
                           </label>
                   </div>
               </div>
               </div>
          </div>
        <div class="form-group margintp20">
            <div class="row bordercss">
                <label class="form-label">Implants Details</label>
            </div>
            <div class="row margintp20">
                <div class="col-sm-6">
                    <label class="form-label">Rental Requirement*</label>
                    <mat-select placeholder="Select Rental Requirement" formControlName="rental_requirement" (selectionChange)="addRemoveRentalValidator($event.value)">
                        <mat-option value="">Select Rental Requirement</mat-option>
                        <mat-option [value]="1">Not Required</mat-option>
                        <mat-option [value]="2">Required</mat-option>
                    </mat-select>
                    <div *ngIf="submitted && f.rental_requirement.errors" class="invalid-feedback">
                        <div *ngIf="f.rental_requirement.errors.required">Rental Requirement is required</div>
                    </div>
                </div>
                <div class="col-sm-6"  *ngIf="(IpdForm.controls['rental_requirement'].value == 2)">
                    <label class="form-label">Rental Lists*</label>
                    <mat-select  placeholder="Rental" formControlName="rental_resources_ids" (click)="setSearchValue('rentals')" multiple>
                        <input class="mySearchInput"
                        #rentalSearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'rentals')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="rentalSearch">
                        <mat-option [value]="rental_lists.id" *ngFor="let rental_lists of rental_lists_arr" >{{rental_lists.name}}</mat-option>
                    </mat-select>
                    <div *ngIf="submitted && f.rental_resources_ids.errors" class="invalid-feedback">
                        <div *ngIf="f.rental_resources_ids.errors.required">Rental Lists is required</div>
                    </div>
                </div>
            </div>
            <div class="row margintp20">
                <div class="col-sm-6">
                    <label class="form-label">Consumable Requirement*</label>
                    <mat-select placeholder="Select Consumable Requirement" formControlName="consumable_requirement" (selectionChange)="addRemoveConsumablesValidator($event.value)">
                        <mat-option value="">Select Consumable Requirement</mat-option>
                        <mat-option [value]="1">Not Required</mat-option>
                        <mat-option [value]="2">Required</mat-option>
                    </mat-select>
                    <div *ngIf="submitted && f.consumable_requirement.errors" class="invalid-feedback">
                        <div *ngIf="f.consumable_requirement.errors.required">Consumable Requirement is required</div>
                    </div>
                </div>
                <div class="col-sm-6" *ngIf="(IpdForm.controls['consumable_requirement'].value == 2)">
                    <label class="form-label">Consumables Lists*</label>
                    <mat-select  placeholder="Consumables" formControlName="consumable_resources_ids" (click)="setSearchValue('consumables')" multiple>
                        <input class="mySearchInput"
                        #consumableSearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'consumables')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="consumableSearch">
                        <mat-option [value]="consumable_lists.id" *ngFor="let consumable_lists of consumable_lists_arr" >{{consumable_lists.name}}</mat-option>
                    </mat-select>
                    <div *ngIf="submitted && f.consumable_resources_ids.errors" class="invalid-feedback">
                        <div *ngIf="f.consumable_resources_ids.errors.required">Consumable Lists is required</div>
                    </div>
                </div>
            </div>
        </div>
          <input type="hidden" formControlName="mobile" class="form-control" />
            <div class="card-footer" *ngIf="myrole!=14">
                <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Update</button>
            </div>
            </form>
        </div>
        <div class="col-sm-4" *ngIf="IpdChk">
            <h2>Upload IPD Documents</h2>
            <div class="form-group">
                <label>Select Document Type</label>
                <mat-select [(ngModel)]="doc_type" placeholder="Select Document Type">
                    <mat-option value="">Select Document Type</mat-option>
                    <mat-option [value]="2">Discharge Summary</mat-option>
                    <mat-option [value]="3">Bill Copy</mat-option>
                    <mat-option [value]="7">Diagnostic Report</mat-option>
                    <mat-option value="i_3" *ngIf="IpdForm.controls['payment_mode'].value=='2'">Pre Auth</mat-option>
                    <mat-option value="i_4" *ngIf="IpdForm.controls['payment_mode'].value=='2'">Pre Approval</mat-option>
                    <mat-option value="i_5" *ngIf="IpdForm.controls['payment_mode'].value=='2'">Final Approval</mat-option>
                    <mat-option value="i_6" *ngIf="IpdForm.controls['payment_mode'].value=='2' || IpdForm.controls['payment_mode'].value=='3'">Settlement Letter</mat-option>
                    <mat-option [value]="8">Disbursement Letter</mat-option>
                    <mat-option [value]="4">Other Document</mat-option>

                </mat-select>
            </div>
            <div class="form-group">
                <label>Upload Documents</label>
                <input [disabled]="uploading" type="file" (change)="selectFile($event)" class="form-control" />
                <span *ngIf="uploading"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
            </div>

            <div class="list-group list-group-flush list-group-hoverable">
                <p *ngIf="fileDeleting"><i class="fa fa-spin fa-spinner"></i> deleting file...</p>
                <div class="list-group-item" *ngFor="let upload of allUploads">
                    <div class="row align-items-center">
                        <div class="col text-truncate">
                            <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">View File</a>
                            <a *ngIf="myrole=='1' || myrole=='4' || myrole=='5' || myrole=='8'" class="delete-file" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                            [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile(upload.id)" (cancel)="cancelClicked = true"
                            confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                            [appendToBody]="true"><i class="fa fa-trash"></i></a>

                            <span class="badge badge-danger" *ngIf='upload.upload_type==1'>Aadhar</span>
                            <span class="badge badge-info" *ngIf='upload.upload_type==2'>Discharge Summary</span>
                            <span class="badge badge-success" *ngIf='upload.upload_type==3'>Bill Copy</span>
                            <span class="badge badge-primary" *ngIf='upload.upload_type==7'>Diagnostic Report</span>
                            <span class="badge badge-secondary" *ngIf='upload.upload_type==8'>Disbursement Letter</span>
                            <span class="badge badge-danger" *ngIf='upload.upload_type==4'>Other Doc</span>
                            <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                        </div>
                    </div>
                </div>
                <div class="list-group-item" *ngFor="let upload1 of alluploaded_Insurancedocs">
                    <div class="row align-items-center">
                        <div class="col text-truncate" *ngIf='upload1.upload_type==3 || upload1.upload_type==4 || upload1.upload_type==5 || upload1.upload_type==6'>
                            <a href="{{s3url}}{{upload1.filepath}}" target="_blank" class="text-body d-block">View File</a>
                            <a *ngIf="myrole=='1' || myrole=='4' || myrole=='5'" class="delete-file" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                            [cancelText]="cancelText" [placement]="placement" (confirm)="removeFileInsurance(upload1.id)" (cancel)="cancelClicked = true"
                            confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                            [appendToBody]="true"><i class="fa fa-trash"></i></a>



                            <span class="badge badge-danger" *ngIf='upload1.upload_type==3'>Pre Auth</span>
                            <span class="badge badge-info" *ngIf='upload1.upload_type==4'>Pre Approval</span>
                            <span class="badge badge-success" *ngIf='upload1.upload_type==5'>Final Approval</span>
                            <span class="badge badge-danger" *ngIf='upload1.upload_type==6'>Settlement Letter</span>

                            <small class="d-block text-muted text-truncate mt-n1">{{upload1.filepath}}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
